module.exports = __webpack_public_path__ + "static/media/YF32_4.fd552c28.jpg";